import { Pagination, Select, Spin, Table as BaseTable, Typography } from 'antd';
import { useMemo } from 'react';

import { getRange } from '@pages/DublicateClients/utils';

import { PF } from '@pages/DublicateClients/data/constants';
import type {
  DublicateClientModel,
  TableProps,
} from '@pages/DublicateClients/types';

import type { FC } from 'react';

const { Text } = Typography;

export const Table: FC<TableProps> = ({
  isPageLoading,
  isFetching,
  data,
  pagination: { PageN, ItemsPerPage, Total },
  onPaginate,
  onPageSizeChange,
  columns,
}) => {
  const { from, to } = useMemo(
    () => getRange({ ItemsPerPage, Total, PageN }),
    [ItemsPerPage, Total, PageN]
  );

  if (isPageLoading) {
    return (
      <div className={`${PF}_table_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${PF}_table_container`}>
      <BaseTable<DublicateClientModel>
        columns={columns}
        dataSource={data}
        rowKey={({ Id }) => Id}
        pagination={false}
        size="middle"
        loading={isFetching}
      />
      {data?.length > 0 && (
        <div className={`${PF}_table_pagination`}>
          <div className={`${PF}_table_pagination_left`}>
            <Pagination
              current={PageN}
              total={Total}
              pageSize={ItemsPerPage}
              showSizeChanger={false}
              onChange={onPaginate}
            />
            <Text>
              Показаны результаты с {from} по {to} из {Total}
            </Text>
          </div>
          <div className={`${PF}_table_pagination_right`}>
            <Select
              value={ItemsPerPage}
              onChange={onPageSizeChange}
              popupMatchSelectWidth={false}
              options={[10, 20, 50, 100].map((n) => ({ label: n, value: n }))}
              className="select"
            />
            <Text>результатов на странице</Text>
          </div>
        </div>
      )}
    </div>
  );
};
